module.exports = __webpack_public_path__ + "static/net-seeklogo.com-f9b8f1c23e0e42a3c434568e3c773e46.svg";